import React, { useState, useContext, useEffect } from "react";
import { IntlProvider } from "react-intl";
import styled, { css } from "styled-components";

import { PAloginSBwidget, PAloginSBemail } from "../PAloginSBs";

import PAgkRefund from "../ffr/PAgkRefund";

import PAloginSocials from "../PAloginSocials";
import PAloginStats from "../login/PAloginStats";

import PAviGroup, { vi } from "./PAviGroup";
import { PAviItems } from "./PAviItems";
import PAvi from "./PAvi";

import PAtabs from "../PAtabs";
import PAh2 from "../PAh2";
import { createBrowserHistory } from "history";
import { PAinfoCollapsible } from '../uikit2';
import uniqid from "uniqid";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Button,
  Breadcrumbs,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock
} from "xsolla-uikit";

import {
  PAchart1,
  PAloginUsersFake,
  PAchartMap
} from "../PAcharts";
import {
  PAlogin0fake,
  PAloginSocialfake,

  PAchart1fake,
  PAchart2
} from "../PAchart2";

import {
  PAConnectorCard,
  PAconnectorGTM,
  PAconnectorGA,
  PAconnectorFB,
  PAconnectorPN,
  PAconnectorTW,
  PAconnectorMCH,
  PAconnectorWH,
  PAconnectorZapier,
  PAconnectorInv
} from "../PAconnectors";

import PAusersSubscribers from "../support/PAusersSubscribers";

import CardNew from "../PAcardNew";
import { ContextConsumer } from "../../App";
import { Link } from "react-router-dom";

import merge from "deepmerge";

import SwitchExample from "../SwitchExample";
import PAContentBlock from "../PAContentBlock";
import formGroup from "xsolla-uikit/lib/form-group";
import { PApromos } from "./PApromos";

export default function PAingame({ hist, status = "active" }) {
  let [state, setState] = useState({
    twoCols: false,
    action: "cat" //users'settings''users'widget'
  });

  const [action, setAction] = useState();

  const handleLink = (stat = state.action) => {
    // setState({
    //   action: stat
    // });
  };

  // const history = createBrowserHistory();

  // const unlisten = history.listen((location, action) => {
  // location is an object like window.location
  // console.log(action, location.pathname, location.state);
  // });
  // debugger;
  useEffect(() => {
    console.log("hist = ", hist);
    let newAction = hist.match.params.keyId || "users";
    console.log("newAction = ", newAction);

    if (!action) {
      setAction(newAction);
    }

    if (newAction && newAction !== action) {
      hist.history.push(`/ingame/${newAction}`);
      setAction(newAction);
    }

    if (
      action &&
      newAction &&
      hist.location.pathname !== `/ingame/${newAction}`
    ) {
      // debugger;
      hist.history.push(`/ingame/${newAction}`);
      debugger;
      setAction(newAction);
    }

    return () => {};
  }, [hist]);

  return (

      <div className="xsui-width">
        <FormGroup indentation="md">
          <div style={{ display: "flex" }}>
            <Breadcrumbs
              //.xsui-breadcrumbs_label {max-width: 100% !important;} //TODO: fix
              items={[
                {
                  label: "In-game Store",
                  to: "/microtransactions/cat"
                }
              ]}
            />
            <PAtabs
              appearance="secondary"
              active={action}
              handleTab={nw => {
                // let url = hist.match.location
                hist.history.push(`/ingame/${nw}`);
                // setState({
                //   ...state,
                //   action: nw
                // });
              }}
              items={[
                // {
                //   name: "Statistics",
                //   stateName: "stats",
                //   icon: "analytics"
                // },
                // {
                //   name: (
                //     <span>
                //       Users&nbsp;&nbsp;
                //       <Pill appearance="active">
                //         {/* <StatusDot
                //     status="enabled"
                //     ></StatusDot> */}
                //         +8
                //       </Pill>
                //     </span>
                //   ),
                //   stateName: "users",
                //   icon: "profile"
                // },
                {
                  name: (
                    <span style={{ display: "flex" }}>
                      Virtual items&nbsp;&nbsp;

                    </span>
                  ),
                  stateName: "cat",
                  // icon: "list-view"
                },

                {
                  name: (
                    <span style={{ display: "flex" }}>
                      Virtual currency&nbsp;&nbsp;
                      <span
                        style={{
                          color: "currentColor",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: 24,
                          height: 24,
                          fontSize: 11,
                          display: "flex",
                          border: "1px solid #baceec",
                          borderRadius: 100
                        }}
                      >
                        2
                      </span>
                    </span>
                  ),
                  stateName: "vc",
                  // icon: "list-view"
                },

                {
                  name: (
                    <span style={{ display: "flex" }}>
                      Promotions&nbsp;&nbsp;
                      <StatusDot
                        status="enabled"
                      ></StatusDot>
                      {/* <Pill appearance = 'active'> */}
                      {/* {' '} */}
                      {/* </Pill> */}
                    </span>
                  ),
                  stateName: "promos",
                  // icon: "redo"
                },
                {
                  name: (
                    <span style={{ display: "flex" }}>
                      Refund policy
                      {/* <Pill appearance = 'active'> */}
                      {/* {' '}<StatusDot
                    status="error"
                    ></StatusDot> */}
                      {/* </Pill> */}
                    </span>
                  ),
                  stateName: "refund",
                  // icon: "redo"
                },
              ]}
            />
          </div>
        </FormGroup>

        {/* <FormGroup indentation='xs'>
          <div className="store-card-content__description">
            Sell in-game items that players purchase with virtual or
            real currency.
          </div>
          <a
            href="https://developers.xsolla.com/doc/store/#guides_store_monetization_options_virtual_items"
            className="store-card-content__doc-link"
            target="_blank"
          >
            <span>Documentation</span>
            <i
              className="xsui-icon xsui-icon-new-tab"
              style={{ fontSize: 24, color: "rgb(0, 115, 247)" }}
            />
          </a>
        </FormGroup> */}

        <div
          style={{
            position: "relative",
            top: 0,
            display: state.twoCols ? "grid" : "auto",
            // gridTemplateColumns: "repeat(2, 1fr)",
            gridTemplateColumns: state.twoCols ? "1fr 2.5fr" : "auto",
            // gridTemplateRows: '200px',
            gridColumnGap: "2%",
            gridRowGap: "16px"
            // width: "100%"
          }}
        >
          {action !== "stats" && action !== "users" && action !== "refund" && (
            <ContentBlock>
              <div
                style={{
                  backgroundColor: "rgb(250, 251, 252)",
                  position: "absolute",
                  marginTop: 56,
                  left: 0,
                  right: 0,
                  height: 140,
                  zIndex: 0
                }}
              />

             {false && <FormGroup
                indentation="lg"
                style={{
                  position: "sticky",
                  top: 0,
                  marginTop: -24
                }}
              >
                <PAtabs
                  // extra={<Button size="sm" appearance="secondary">Go to Store Builder</Button>}
                  active={action}
                  handleTab={nw => {
                    // let url = hist.match.location
                    hist.history.push(`/ingame/${nw}`);
                    // setState({
                    //   ...state,
                    //   action: nw
                    // });
                  }}
                  items={[
                    {
                      name: "Virtual items",
                      stateName: "cat",
                      icon: "list-view"
                    },
                    {
                      name: "Virtual currency",
                      stateName: "vc",
                      icon: "list-view"
                    },
                    {
                      name: "Achievemnts",
                      stateName: "ach",
                      icon: "list-view"
                    },

                    {
                      name: "Promotions",
                      stateName: "promos",
                      icon: "exclamation-alert"
                    }

                    // {
                    //   name: "Storefront",
                    //   stateName: "storefront",
                    //   icon: "tile-view"
                    // },
                    // {
                    //   name: '(sb inline)',
                    //   stateName: 'widgetinline',
                    // },
                    // {
                    //   name: "Refund policy",
                    //   stateName: "refund",
                    //   icon: "exclamation-alert"
                    // }
                  ]}
                />
              </FormGroup>}

              {action === "cat" && (
                <div className="">
                  <Anchor id="cat" />
                  {/* <FormGroup indentation='xlg'>
                <PAvi/>
              </FormGroup> */}
                  {/* <FormGroup border='xlg'/> */}

                  <PAingameCat />
                </div>
              )}

              {action === "promos" && (
                <FormGroup
                  indentation="lg"
                  style={{
                    position: "relative",
                    zIndex: 1
                  }}
                >
                  <FormGroup indentation="lg">
                    {/* <CardNew wave={false}> */}
                    {/* <ContentBlock> */}
                    <Anchor id="promos" />

                    <PAh2 title="Promotions">
                      <div
                        style={{
                          flexGrow: 1,
                          justifyContent: "flex-end",
                          display: "flex"
                        }}
                      >
                        <Button
                          // appearance="outline-secondary"
                          appearance="secondary"
                          size="sm"
                        >
                          + New Promotion
                        </Button>
                      </div>
                    </PAh2>

                    <FormGroup>
                      <PApromos />
                    </FormGroup>

                    {/* </ContentBlock> */}
                    {/* </CardNew> */}
                  </FormGroup>
                </FormGroup>
              )}
            </ContentBlock>
          )}




          {action === "users" && (
            <ContentBlock>
              <Anchor id="users" />
              <PAh2 title="Users" indentation="lg" />

              <FormGroup indentation="xlg" style={{ width: "100%" }}>
                <PAinfoCollapsible
                  title="Connect apps"
                  indentation="lg"
                  isOpen={true}
                >
                  {/* <Notification style={{
                    width: '100%', marginBottom: 44,}}> */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 340px)",
                      gridColumnGap: "16px",
                      gridRowGap: "16px"
                    }}
                  >
                    <PAconnectorInv />

                    <PAconnectorZapier>
                      Sync customers' data with any other service.
                    </PAconnectorZapier>
                  </div>
                </PAinfoCollapsible>
                {/* </Notification> */}
              </FormGroup>
              <br />
              <FormGroup border="xlg" style={{ width: "100%" }}>
                <PAusersSubscribers title="Users and customers" />
              </FormGroup>
            </ContentBlock>
          )}






          {action === "stats" && (
            <div className="">
              <Anchor id="stats" />
              <PAloginStats title="123" />
            </div>
          )}

          {action === "refund" && (
            <FormGroup indentation="lg">
              <FormGroup indentation="lg">
                {/* <CardNew wave={false}> */}
                <ContentBlock>
                  <Anchor id="refund" />

                  <PAh2
                    title="Refund policy configurator"
                    indentation="lg"
                  ></PAh2>

                  <PAgkRefund type="ingame" />
                </ContentBlock>
                {/* </CardNew> */}
              </FormGroup>
            </FormGroup>
          )}
        </div>
        {/* </div> */}
      </div>

  );
}

const PAingameCat = ({}) => {
  return (
    <FormGroup>
      <PAh2 title="Virtual items" />
      <PAviGroup showAsPage={false} />
    </FormGroup>
  );
};

export function Anchor({ id = uniqid() }) {
  return (
    <div>
      <a id={id} />
    </div>
  );
}

const CSSedit = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  background: #0000007a;
  transition: opacity 150ms ease-in-out;
  opacity: 0;
  z-index: 1000;
  &:hover {
    opacity: 1;
  }
`;


